// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M10.5,4.5 L1.5,4.5 C0.671484232,4.5 0,5.17265618 0,6 L0,8.25 C0,8.66414094 0.335859418,9 0.75,9 L1.5,9 L1.5,11.25 C1.5,11.6641409 1.83585942,12 2.25,12 L9.75,12 C10.1641409,12 10.5,11.6641409 10.5,11.25 L10.5,9 L11.25,9 C11.6641409,9 12,8.66414094 12,8.25 L12,6 C12,5.17265618 11.3273435,4.5 10.5,4.5 Z M9,10.5 L3,10.5 L3,8.25 L9,8.25 L9,10.5 Z M10.125,6.9375 C9.81445312,6.9375 9.5625,6.68554688 9.5625,6.375 C9.5625,6.06398463 9.81445312,5.8125 10.125,5.8125 C10.4355469,5.8125 10.6875,6.06398463 10.6875,6.375 C10.6875,6.68671846 10.4367185,6.9375 10.125,6.9375 Z M3,1.5 L8.37890625,1.5 L9,2.12132835 L9,3.75 L10.5,3.75 L10.5,1.81054688 C10.5,1.61170292 10.4208984,1.42101574 10.2802734,1.28039074 L9.21972656,0.219843864 C9.07968736,0.0791015625 8.88750029,0 8.69062471,0 L2.25,0 C1.83609366,0 1.5,0.33585906 1.5,0.75 L1.5,3.75 L3,3.75 L3,1.5 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(Print);
